export const addUtilityToCart = (itemDetail) => ({
    type: 'ADD_UTILITY_TO_CART',
    payload: itemDetail
});

export const updateUtilityCart = (selectedItems) => ({
    type: 'UPDATE_UTILITY_CART',
    payload: selectedItems
});

export const removeUtilityFromCart = (remainingItems) => ({
    type: 'REMOVE_UTILITY_FROM_CART',
    payload: remainingItems
});

export const resetUtilityCart = () => ({
    type: 'RESET_UTILITY_CART'
});